















import { Component, Vue } from 'vue-property-decorator';
import Democracy from './Democracy.vue';
import Referendums from './Referendums.vue';
import Proposals from './Proposals.vue';
import Summary from './Summary.vue';
import SubmitProposal from './SubmitProposal.vue';
import Extrinsics from '@/views/Extrinsics.vue';
import Preimage from './Preimage.vue';

@Component({
  components: {
    Democracy,
    Referendums,
    Proposals,
    Summary,
		SubmitProposal,
    Extrinsics,
    Preimage,
  },
})
export default class DemocracyWrapper extends Vue {
  public activeTab: number = 0;
  public democracyTab: number = 0;

}
